<template>
  <div class="CasamentosSearch">
    <div class="row d-flex align-items-top m-0 p-0">
      <div class="col-3 form-group m-0 p-0 pr-4">
        <label for="status"
               class="CasamentosSearch_label m-0 p-0 mb-1">Status</label>
        <v-select id="status"
                  v-model="localData.status"
                  :options="selects.status"
                  :reduce="status => status.value"
                  class="form-control form-control-sm"
                  name="status"
                  placeholder="Selecione" />
      </div>
      <div class="col-3 form-group m-0 p-0 pr-4">
        <label for="tipo_data"
               class="CasamentosSearch_label m-0 p-0 mb-1">Tipo de data</label>
        <v-select id="tipo_data"
                  v-model="localData.tipo_data"
                  :options="selects.tipo_data"
                  :reduce="tipo_data => tipo_data.value"
                  class="form-control form-control-sm"
                  name="tipo_data"
                  placeholder="Selecione" />
      </div>
      <div v-if="localData.tipo_data"
           class="col-4 form-group m-0 p-0 pr-5">
        <label for="data"
               class="CasamentosSearch_label m-0 p-0 mb-1">Data</label>
        <div id="data"
             class="d-inline-flex align-items-top">
          <div class="form-group m-0 p-0">
            <input id="inicio"
                   v-model="localData.data_inicial"
                   v-validate="{required: !!localData.tipo_data}"
                   type="date"
                   name="inicio"
                   class="form-control form-control-sm"
                   :class="{'is-invalid': errors.has('inicio')}"
                   :disabled="!localData.tipo_data">
            <span v-if="errors.has('inicio')"
                  class="invalid-feedback">
              {{ localData.tipo_data && !localData.data_inicial ? "Campo obrigatório" : errors.first("inicio") }}
            </span>
          </div>
          <p class="p-0 m-0 mx-2 mt-1 CasamentosSearch_label">
            até
          </p>
          <div class="form-group m-0 p-0">
            <input id="fim"
                   v-model="localData.data_final"
                   v-validate="{required: !!localData.tipo_data}"
                   type="date"
                   name="fim"
                   class="form-control form-control-sm"
                   :class="{'is-invalid': errors.has('fim')}"
                   :disabled="!localData.tipo_data">
            <span v-if="errors.has('fim')"
                  class="invalid-feedback">
              {{ localData.tipo_data && !localData.data_final ? "Campo obrigatório" : errors.first("fim") }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="row d-flex align-items-top m-0 p-0 mt-2">
      <div class="col-4 m-0 p-0 pr-4">
        <label for="matricula"
               class="ComunicacoesSearch_label  m-0 p-0 mb-1">
          Número da matrícula
        </label>
        <input id="matricula"
               v-model="localData.matricula"
               v-validate="{required: localData.status === 'TODAS' && !localData.nome_registrado}"
               v-mask="'999999 99 99 9999 9 99999 999 9999999 99'"
               type="text"
               name="matricula"
               class="form-control form-control-sm"
               @keyup.enter="search()">
      </div>
      <div class="col-8 m-0 p-0">
        <label for="nome"
               class="ComunicacoesSearch_label m-0 p-0 mb-1">
          Nome do registrado
        </label>
        <input id="nome"
               v-model="localData.nome_registrado"
               v-validate="{required: localData.status === 'TODAS' && !localData.matricula}"
               type="text"
               name="nome"
               class="form-control form-control-sm"
               @keyup.enter="search()">
      </div>
      <div class="row">
        <div class="col-12 mt-2">
          <span v-if="localData.status === 'TODAS'"
                class="text-error-fields">
            * Obrigatório o preenchimento do <u class="bold">número da matrícula</u> ou <u class="bold">nome do registrado</u>
          </span>
        </div>
      </div>
    </div>
    <div class="col-12 d-flex justify-content-end align-items-center m-0 p-0 mt-3">
      <button class="btn btn-sm btn-primary px-4"
              @click="search()">
        Filtrar
      </button>
    </div>
  </div>
</template>
<script>
  //Outros
  import {mapGetters} from "vuex"

  export default {
    name: 'SearchCasamentosSearch',
    data () {
      return {
        localData: {
          tipo_registro: ['D', 'C', 'CR'],
          cartorio_id: this.$store.state.auth.cartorio_id,
          tipo: "HABILITACAO_CASAMENTO",
          status: null,
          tipo_data: null,
          data_inicial: null,
          data_final: null,
          matricula: null,
          nome_registrado: null,
          orderBy: 'data_inclusao',
          perPage: 10
        },
        selects: {
          status: [
            {label: 'Todas', value: 'TODAS'},
            {label: 'Todas não cumpridas', value: null},
            {label: 'Vencidas', value: 'VENCIDA'},
            {label: 'A vencer', value: 'A_VENCER'},
            {label: 'Todas cumpridas', value: 'CUMPRIDA'}
          ],
          tipo_data: [
            { label: 'Qualquer data', value: null },
            { label: 'Data Inclusão', value: 'data_inclusao' },
            { label: 'Data Registro', value: 'data_registro' },
            { label: 'Data Cumprimento', value: 'data_cumprimento' },
            { label: 'Data Habilitação', value: 'data_habilitacao' },
            { label: 'Data Publicação', value: 'data_publicacao' },
            { label: 'Data Entrada', value: 'data_entrada' },
            { label: 'Data Casamento', value: 'data_casamento' },
          ],
        },
        todos_registros: true
      }
    },
    computed: {
      ...mapGetters({
        cartorioId: 'auth/getCartorioId'
      })
    },
    methods: {
      async search () {
        if (!this.localData.tipo_registro.length) {
          this.$emit('showError', '', 'Escolha o tipo de registro.')
        }

        const valid = await this.$validator.validate()

        if (!valid) return

        this.$emit('search', this.localData)
      },
    }
  }
</script>
<style lang="scss">
  .CasamentosSearch {
    &_label {
      font-size: 16px;
      font-weight: 500;
      color: #373a3c;
    }

    &_tipos {
      font-size: 16px;
      font-weight: normal;
      color: #000000;

      &_icon {
        width: 18px;
        height: 18px;
      }
    }
  }

  .text-error-fields {
    font-family: Roboto;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: left;
    color: #9c2626;
  }

  .bold {
    font-weight: bold;
  }
</style>
